import { isa as __isa } from "@aws-sdk/smithy-client";
export var AmbiguousRoleResolutionType;
(function (AmbiguousRoleResolutionType) {
    AmbiguousRoleResolutionType["AUTHENTICATED_ROLE"] = "AuthenticatedRole";
    AmbiguousRoleResolutionType["DENY"] = "Deny";
})(AmbiguousRoleResolutionType || (AmbiguousRoleResolutionType = {}));
export var CognitoIdentityProvider;
(function (CognitoIdentityProvider) {
    CognitoIdentityProvider.isa = function (o) {
        return __isa(o, "CognitoIdentityProvider");
    };
})(CognitoIdentityProvider || (CognitoIdentityProvider = {}));
export var ConcurrentModificationException;
(function (ConcurrentModificationException) {
    ConcurrentModificationException.isa = function (o) {
        return __isa(o, "ConcurrentModificationException");
    };
})(ConcurrentModificationException || (ConcurrentModificationException = {}));
export var CreateIdentityPoolInput;
(function (CreateIdentityPoolInput) {
    CreateIdentityPoolInput.isa = function (o) {
        return __isa(o, "CreateIdentityPoolInput");
    };
})(CreateIdentityPoolInput || (CreateIdentityPoolInput = {}));
export var Credentials;
(function (Credentials) {
    Credentials.isa = function (o) { return __isa(o, "Credentials"); };
})(Credentials || (Credentials = {}));
export var DeleteIdentitiesInput;
(function (DeleteIdentitiesInput) {
    DeleteIdentitiesInput.isa = function (o) {
        return __isa(o, "DeleteIdentitiesInput");
    };
})(DeleteIdentitiesInput || (DeleteIdentitiesInput = {}));
export var DeleteIdentitiesResponse;
(function (DeleteIdentitiesResponse) {
    DeleteIdentitiesResponse.isa = function (o) {
        return __isa(o, "DeleteIdentitiesResponse");
    };
})(DeleteIdentitiesResponse || (DeleteIdentitiesResponse = {}));
export var DeleteIdentityPoolInput;
(function (DeleteIdentityPoolInput) {
    DeleteIdentityPoolInput.isa = function (o) {
        return __isa(o, "DeleteIdentityPoolInput");
    };
})(DeleteIdentityPoolInput || (DeleteIdentityPoolInput = {}));
export var DescribeIdentityInput;
(function (DescribeIdentityInput) {
    DescribeIdentityInput.isa = function (o) {
        return __isa(o, "DescribeIdentityInput");
    };
})(DescribeIdentityInput || (DescribeIdentityInput = {}));
export var DescribeIdentityPoolInput;
(function (DescribeIdentityPoolInput) {
    DescribeIdentityPoolInput.isa = function (o) {
        return __isa(o, "DescribeIdentityPoolInput");
    };
})(DescribeIdentityPoolInput || (DescribeIdentityPoolInput = {}));
export var DeveloperUserAlreadyRegisteredException;
(function (DeveloperUserAlreadyRegisteredException) {
    DeveloperUserAlreadyRegisteredException.isa = function (o) {
        return __isa(o, "DeveloperUserAlreadyRegisteredException");
    };
})(DeveloperUserAlreadyRegisteredException || (DeveloperUserAlreadyRegisteredException = {}));
export var ErrorCode;
(function (ErrorCode) {
    ErrorCode["ACCESS_DENIED"] = "AccessDenied";
    ErrorCode["INTERNAL_SERVER_ERROR"] = "InternalServerError";
})(ErrorCode || (ErrorCode = {}));
export var ExternalServiceException;
(function (ExternalServiceException) {
    ExternalServiceException.isa = function (o) {
        return __isa(o, "ExternalServiceException");
    };
})(ExternalServiceException || (ExternalServiceException = {}));
export var GetCredentialsForIdentityInput;
(function (GetCredentialsForIdentityInput) {
    GetCredentialsForIdentityInput.isa = function (o) {
        return __isa(o, "GetCredentialsForIdentityInput");
    };
})(GetCredentialsForIdentityInput || (GetCredentialsForIdentityInput = {}));
export var GetCredentialsForIdentityResponse;
(function (GetCredentialsForIdentityResponse) {
    GetCredentialsForIdentityResponse.isa = function (o) {
        return __isa(o, "GetCredentialsForIdentityResponse");
    };
})(GetCredentialsForIdentityResponse || (GetCredentialsForIdentityResponse = {}));
export var GetIdInput;
(function (GetIdInput) {
    GetIdInput.isa = function (o) { return __isa(o, "GetIdInput"); };
})(GetIdInput || (GetIdInput = {}));
export var GetIdResponse;
(function (GetIdResponse) {
    GetIdResponse.isa = function (o) { return __isa(o, "GetIdResponse"); };
})(GetIdResponse || (GetIdResponse = {}));
export var GetIdentityPoolRolesInput;
(function (GetIdentityPoolRolesInput) {
    GetIdentityPoolRolesInput.isa = function (o) {
        return __isa(o, "GetIdentityPoolRolesInput");
    };
})(GetIdentityPoolRolesInput || (GetIdentityPoolRolesInput = {}));
export var GetIdentityPoolRolesResponse;
(function (GetIdentityPoolRolesResponse) {
    GetIdentityPoolRolesResponse.isa = function (o) {
        return __isa(o, "GetIdentityPoolRolesResponse");
    };
})(GetIdentityPoolRolesResponse || (GetIdentityPoolRolesResponse = {}));
export var GetOpenIdTokenForDeveloperIdentityInput;
(function (GetOpenIdTokenForDeveloperIdentityInput) {
    GetOpenIdTokenForDeveloperIdentityInput.isa = function (o) {
        return __isa(o, "GetOpenIdTokenForDeveloperIdentityInput");
    };
})(GetOpenIdTokenForDeveloperIdentityInput || (GetOpenIdTokenForDeveloperIdentityInput = {}));
export var GetOpenIdTokenForDeveloperIdentityResponse;
(function (GetOpenIdTokenForDeveloperIdentityResponse) {
    GetOpenIdTokenForDeveloperIdentityResponse.isa = function (o) {
        return __isa(o, "GetOpenIdTokenForDeveloperIdentityResponse");
    };
})(GetOpenIdTokenForDeveloperIdentityResponse || (GetOpenIdTokenForDeveloperIdentityResponse = {}));
export var GetOpenIdTokenInput;
(function (GetOpenIdTokenInput) {
    GetOpenIdTokenInput.isa = function (o) {
        return __isa(o, "GetOpenIdTokenInput");
    };
})(GetOpenIdTokenInput || (GetOpenIdTokenInput = {}));
export var GetOpenIdTokenResponse;
(function (GetOpenIdTokenResponse) {
    GetOpenIdTokenResponse.isa = function (o) {
        return __isa(o, "GetOpenIdTokenResponse");
    };
})(GetOpenIdTokenResponse || (GetOpenIdTokenResponse = {}));
export var IdentityDescription;
(function (IdentityDescription) {
    IdentityDescription.isa = function (o) {
        return __isa(o, "IdentityDescription");
    };
})(IdentityDescription || (IdentityDescription = {}));
export var IdentityPool;
(function (IdentityPool) {
    IdentityPool.isa = function (o) { return __isa(o, "IdentityPool"); };
})(IdentityPool || (IdentityPool = {}));
export var IdentityPoolShortDescription;
(function (IdentityPoolShortDescription) {
    IdentityPoolShortDescription.isa = function (o) {
        return __isa(o, "IdentityPoolShortDescription");
    };
})(IdentityPoolShortDescription || (IdentityPoolShortDescription = {}));
export var InternalErrorException;
(function (InternalErrorException) {
    InternalErrorException.isa = function (o) {
        return __isa(o, "InternalErrorException");
    };
})(InternalErrorException || (InternalErrorException = {}));
export var InvalidIdentityPoolConfigurationException;
(function (InvalidIdentityPoolConfigurationException) {
    InvalidIdentityPoolConfigurationException.isa = function (o) {
        return __isa(o, "InvalidIdentityPoolConfigurationException");
    };
})(InvalidIdentityPoolConfigurationException || (InvalidIdentityPoolConfigurationException = {}));
export var InvalidParameterException;
(function (InvalidParameterException) {
    InvalidParameterException.isa = function (o) {
        return __isa(o, "InvalidParameterException");
    };
})(InvalidParameterException || (InvalidParameterException = {}));
export var LimitExceededException;
(function (LimitExceededException) {
    LimitExceededException.isa = function (o) {
        return __isa(o, "LimitExceededException");
    };
})(LimitExceededException || (LimitExceededException = {}));
export var ListIdentitiesInput;
(function (ListIdentitiesInput) {
    ListIdentitiesInput.isa = function (o) {
        return __isa(o, "ListIdentitiesInput");
    };
})(ListIdentitiesInput || (ListIdentitiesInput = {}));
export var ListIdentitiesResponse;
(function (ListIdentitiesResponse) {
    ListIdentitiesResponse.isa = function (o) {
        return __isa(o, "ListIdentitiesResponse");
    };
})(ListIdentitiesResponse || (ListIdentitiesResponse = {}));
export var ListIdentityPoolsInput;
(function (ListIdentityPoolsInput) {
    ListIdentityPoolsInput.isa = function (o) {
        return __isa(o, "ListIdentityPoolsInput");
    };
})(ListIdentityPoolsInput || (ListIdentityPoolsInput = {}));
export var ListIdentityPoolsResponse;
(function (ListIdentityPoolsResponse) {
    ListIdentityPoolsResponse.isa = function (o) {
        return __isa(o, "ListIdentityPoolsResponse");
    };
})(ListIdentityPoolsResponse || (ListIdentityPoolsResponse = {}));
export var ListTagsForResourceInput;
(function (ListTagsForResourceInput) {
    ListTagsForResourceInput.isa = function (o) {
        return __isa(o, "ListTagsForResourceInput");
    };
})(ListTagsForResourceInput || (ListTagsForResourceInput = {}));
export var ListTagsForResourceResponse;
(function (ListTagsForResourceResponse) {
    ListTagsForResourceResponse.isa = function (o) {
        return __isa(o, "ListTagsForResourceResponse");
    };
})(ListTagsForResourceResponse || (ListTagsForResourceResponse = {}));
export var LookupDeveloperIdentityInput;
(function (LookupDeveloperIdentityInput) {
    LookupDeveloperIdentityInput.isa = function (o) {
        return __isa(o, "LookupDeveloperIdentityInput");
    };
})(LookupDeveloperIdentityInput || (LookupDeveloperIdentityInput = {}));
export var LookupDeveloperIdentityResponse;
(function (LookupDeveloperIdentityResponse) {
    LookupDeveloperIdentityResponse.isa = function (o) {
        return __isa(o, "LookupDeveloperIdentityResponse");
    };
})(LookupDeveloperIdentityResponse || (LookupDeveloperIdentityResponse = {}));
export var MappingRule;
(function (MappingRule) {
    MappingRule.isa = function (o) { return __isa(o, "MappingRule"); };
})(MappingRule || (MappingRule = {}));
export var MappingRuleMatchType;
(function (MappingRuleMatchType) {
    MappingRuleMatchType["CONTAINS"] = "Contains";
    MappingRuleMatchType["EQUALS"] = "Equals";
    MappingRuleMatchType["NOT_EQUAL"] = "NotEqual";
    MappingRuleMatchType["STARTS_WITH"] = "StartsWith";
})(MappingRuleMatchType || (MappingRuleMatchType = {}));
export var MergeDeveloperIdentitiesInput;
(function (MergeDeveloperIdentitiesInput) {
    MergeDeveloperIdentitiesInput.isa = function (o) {
        return __isa(o, "MergeDeveloperIdentitiesInput");
    };
})(MergeDeveloperIdentitiesInput || (MergeDeveloperIdentitiesInput = {}));
export var MergeDeveloperIdentitiesResponse;
(function (MergeDeveloperIdentitiesResponse) {
    MergeDeveloperIdentitiesResponse.isa = function (o) {
        return __isa(o, "MergeDeveloperIdentitiesResponse");
    };
})(MergeDeveloperIdentitiesResponse || (MergeDeveloperIdentitiesResponse = {}));
export var NotAuthorizedException;
(function (NotAuthorizedException) {
    NotAuthorizedException.isa = function (o) {
        return __isa(o, "NotAuthorizedException");
    };
})(NotAuthorizedException || (NotAuthorizedException = {}));
export var ResourceConflictException;
(function (ResourceConflictException) {
    ResourceConflictException.isa = function (o) {
        return __isa(o, "ResourceConflictException");
    };
})(ResourceConflictException || (ResourceConflictException = {}));
export var ResourceNotFoundException;
(function (ResourceNotFoundException) {
    ResourceNotFoundException.isa = function (o) {
        return __isa(o, "ResourceNotFoundException");
    };
})(ResourceNotFoundException || (ResourceNotFoundException = {}));
export var RoleMapping;
(function (RoleMapping) {
    RoleMapping.isa = function (o) { return __isa(o, "RoleMapping"); };
})(RoleMapping || (RoleMapping = {}));
export var RoleMappingType;
(function (RoleMappingType) {
    RoleMappingType["RULES"] = "Rules";
    RoleMappingType["TOKEN"] = "Token";
})(RoleMappingType || (RoleMappingType = {}));
export var RulesConfigurationType;
(function (RulesConfigurationType) {
    RulesConfigurationType.isa = function (o) {
        return __isa(o, "RulesConfigurationType");
    };
})(RulesConfigurationType || (RulesConfigurationType = {}));
export var SetIdentityPoolRolesInput;
(function (SetIdentityPoolRolesInput) {
    SetIdentityPoolRolesInput.isa = function (o) {
        return __isa(o, "SetIdentityPoolRolesInput");
    };
})(SetIdentityPoolRolesInput || (SetIdentityPoolRolesInput = {}));
export var TagResourceInput;
(function (TagResourceInput) {
    TagResourceInput.isa = function (o) {
        return __isa(o, "TagResourceInput");
    };
})(TagResourceInput || (TagResourceInput = {}));
export var TagResourceResponse;
(function (TagResourceResponse) {
    TagResourceResponse.isa = function (o) {
        return __isa(o, "TagResourceResponse");
    };
})(TagResourceResponse || (TagResourceResponse = {}));
export var TooManyRequestsException;
(function (TooManyRequestsException) {
    TooManyRequestsException.isa = function (o) {
        return __isa(o, "TooManyRequestsException");
    };
})(TooManyRequestsException || (TooManyRequestsException = {}));
export var UnlinkDeveloperIdentityInput;
(function (UnlinkDeveloperIdentityInput) {
    UnlinkDeveloperIdentityInput.isa = function (o) {
        return __isa(o, "UnlinkDeveloperIdentityInput");
    };
})(UnlinkDeveloperIdentityInput || (UnlinkDeveloperIdentityInput = {}));
export var UnlinkIdentityInput;
(function (UnlinkIdentityInput) {
    UnlinkIdentityInput.isa = function (o) {
        return __isa(o, "UnlinkIdentityInput");
    };
})(UnlinkIdentityInput || (UnlinkIdentityInput = {}));
export var UnprocessedIdentityId;
(function (UnprocessedIdentityId) {
    UnprocessedIdentityId.isa = function (o) {
        return __isa(o, "UnprocessedIdentityId");
    };
})(UnprocessedIdentityId || (UnprocessedIdentityId = {}));
export var UntagResourceInput;
(function (UntagResourceInput) {
    UntagResourceInput.isa = function (o) {
        return __isa(o, "UntagResourceInput");
    };
})(UntagResourceInput || (UntagResourceInput = {}));
export var UntagResourceResponse;
(function (UntagResourceResponse) {
    UntagResourceResponse.isa = function (o) {
        return __isa(o, "UntagResourceResponse");
    };
})(UntagResourceResponse || (UntagResourceResponse = {}));
//# sourceMappingURL=index.js.map